import _flagsInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/flags";
import { useAppContext } from '../context/context';
export var useFeatureFlag = function useFeatureFlag(flagName) {
  var _flags$flagName;
  var _useAppContext = useAppContext(),
    flags = _flagsInstanceProperty(_useAppContext.state);
  return (_flags$flagName = flags === null || flags === void 0 ? void 0 : flags[flagName]) !== null && _flags$flagName !== void 0 ? _flags$flagName : false;
};
//# sourceMappingURL=useFeatureFlag.js.map